export const isValueObject = (params: unknown) => {
  if (!params) return false;
  return (
    params &&
    !Array.isArray(params) &&
    typeof params === 'object' &&
    params !== null
  );
};
